import { yupResolver } from '@hookform/resolvers/yup';
import { IEMVDataFormMeta } from '@Modules/admin/archiving/containers/formHandlers/validTransactionInquiry/transactionHistory/emvData/EmvDataFormMeta';
import CustomFieldSet from '@Modules/core/components/CustomFieldSet';
import CustomFormControl from '@Modules/core/components/form/CustomFormControl';
import CustomInput from '@Modules/core/components/form/CustomInput';
import CustomSaveBtn from '@Modules/core/components/form/CustomSaveBtn';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { TFormUIProps } from '@Modules/core/types/FormUIPropsType';
import displayCustomInputs from '@Shared/utils/displayCustomInputs';
import { getFormFieldsName } from '@Shared/utils/getFormFieldsNames';
import React from 'react';
import { useForm } from 'react-hook-form';

type Props = {
  meta: IEMVDataFormMeta,
} & TFormUIProps;

const EMVDataFormUI: React.FC<Props> = ({
  onSubmit,
  isLoading,
  isSubmitting,
  meta,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    // reset,
  } = useForm({ resolver: yupResolver(meta.schema) });

  const fields = getFormFieldsName(meta);
  const terminalCapacityFields = fields.slice(0, 8);
  const terminalDataFields = fields.slice(8, 12);
  const profileExchangeApplicationFields = fields.slice(12, 18);
  const cryptogramFields = fields.slice(18, 24);
  const issuerScriptsFields = fields.slice(24);

  return (
    <CC.Box as={'form'} onSubmit={handleSubmit(onSubmit)}>

      <CC.Flex
        direction={{  base: 'column' }}
        gap={"16px"}
      >
        <CustomFieldSet title="Capacité Terminal" minW="calc((100% - 16px)/2)">
          <CC.SimpleGrid
            columns={{ base: 1, md: 3}}
            gap={4}
            my={4}
            mx={'auto'}
          >
            {displayCustomInputs(
              meta,
              register,
              errors,
              isLoading,
              terminalCapacityFields
            )}
          </CC.SimpleGrid>
        </CustomFieldSet>

        <CustomFieldSet title="Donnée Terminal" minW="calc((100% - 16px)/2)">
          <CC.SimpleGrid
            columns={{ base: 1, lg: 2 }}
            gap={4}
            my={4}
            
          >
            {displayCustomInputs(
              meta,
              register,
              errors,
              isLoading,
              terminalDataFields
            )}
          </CC.SimpleGrid>
        </CustomFieldSet>
      </CC.Flex>

      <CustomFieldSet title="Profile Echange Application">
        <CC.SimpleGrid
          columns={{ base: 1, lg: 2, "2xl": 3 }}
          gap={4}
          my={4}
        >
          {displayCustomInputs(
            meta,
            register,
            errors,
            isLoading,
            profileExchangeApplicationFields
          )}
        </CC.SimpleGrid>
      </CustomFieldSet>

      
      <CC.Flex
        direction={{  base: 'column' }}
        gap={"16px"}
      >
        <CustomFieldSet title="Cryptogram" minW={"60%"}>
          <CC.SimpleGrid
            columns={{ base: 1, lg: 2 }}
            gap={4}
            my={4} 
          >
            {displayCustomInputs(
              meta,
              register,
              errors,
              isLoading,
              cryptogramFields
            )}
          </CC.SimpleGrid>
        </CustomFieldSet>

        <CustomFieldSet title="Scripts Issuer">
          <CC.SimpleGrid
            columns={{ base: 1, md: 2 }}
            gap={4}
            my={4} 
          >
          {
            issuerScriptsFields.map((input, index) => (
              <CustomFormControl key={index} label={meta[input as keyof IEMVDataFormMeta].label} isLoading={isLoading} isInvalid={!!errors[meta[input as keyof IEMVDataFormMeta].name]}>
                  <CustomInput hasError={errors[meta[input as keyof IEMVDataFormMeta].name]} register={register(meta[input as keyof IEMVDataFormMeta].name)} meta={meta[input as keyof IEMVDataFormMeta]}/>
              </CustomFormControl>

            ))
          }
          </CC.SimpleGrid>
        </CustomFieldSet>

      </CC.Flex>

      <CC.HStack my={4} justifyContent={'flex-end'}>
        <CustomSaveBtn isLoading={isLoading} isSubmitting={isSubmitting} />
      </CC.HStack>
    </CC.Box>
  );
};

export default EMVDataFormUI;
